<template>
  <tr>
  	<td>{{ item.id }}</td>
    <td>{{ formatMysqlDate(item.date, 'Do MMM, YYYY') }}</td>
    <td>{{ item.warehouse_from_name }}</td>
    <td>{{ item.warehouse_to_name }}</td>
    <td>{{ status }}</td>
    <td class="align-center justify-center layout px-0">
      <v-icon small class="mr-1" v-if="isPending" color="green" @click="$emit('confirm', item)">done</v-icon>
      <v-icon small class="mr-1" v-if="isPending" color="red" @click="$emit('cancel', item)">clear</v-icon>
      <router-link :to="`/stock-movement/${item.id}`" v-if="hasEditAccess && isPending" title="Edit Stock Movement">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
      <router-link :to="`/stock-movement/${item.id}/view`" title="View Stock Movement">
        <v-icon small class="mr-1">visibility</v-icon>
      </router-link>
      <!-- <a :href="`#/stock-dispatch/${item.id}/print`" v-if="!isCancelled" target="_new" title="Print Stock Movement" class="hidden-sm-and-down">
        <v-icon small class="mr-1">print</v-icon>
      </a> -->
    </td>
  </tr>
</template>
<script>
export default {
  name: 'StockMovementListItem' ,
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.movementStatus.pending
    },

    isApproved () {
      return this.item.status == this.config.movementStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.movementStatus.cancelled
    },

    status () {
      let status = ""
      let statuses = this.config.movementStatus
      
      switch (this.item.status) {
        case statuses.pending:
          status = "Pending"
        break
        case statuses.approved:
          status = "Approved"
        break
        case statuses.cancelled:
          status = "Cancelled"
        break
      }

      return status
    }

  },

  watch: {
    
  }
}
</script>